import { defineNuxtPlugin } from '#app'
import { setQueuedNotificationActionHandler } from '@shared/model'
import { useNotificationActionHandler } from '~/features/notifications/model/useNotificationActionHandler'

/** Обрабатывает отложенные действия из shared/model/useAppReadiness без импорта features там */
export default defineNuxtPlugin({
  name: 'queued-notification-action-bridge',
  setup() {
    const { handleNotificationAction } = useNotificationActionHandler()
    setQueuedNotificationActionHandler(d => handleNotificationAction(d))
  },
})
